import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { attributeDateRange as AttributeDateRange } from 'theme/icon';
import { Tooltip } from 'antd';
import _ from 'lodash';
import { setEndOfDay, setStartOfDay } from 'utils/other';
import { DatePicker } from 'components/UI';
import styles from './styles.scss';

const dateFormat = 'DD.MM.YYYY';

const DateRangeAttribute = props => {
  const { isEditable } = props;
  return (
    <div className={styles.row}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <AttributeDateRange alt="" />
        </div>
        <div className={styles.caption}>
          <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
            <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
          </Tooltip>
        </div>
      </div>
      <div className={styles.body}>
        {isEditable ? (
          <React.Fragment>
            <DatePicker
              errors={props.meta.error}
              isEqualDateAccess={false}
              value={{
                startDate: props.value && props.value.from,
                endDate: props.value && props.value.to,
              }}
              onChange={value => {
                props.onChange({
                  ...props.value,
                  from: value.startDate,
                  to: value.endDate,
                });
              }}
            />
            {props.meta.error && props.meta.error.all && (
              <span className={styles.error}>Значения не могут быть равны</span>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {props.value && (props.value.from || props.value.to) && (
              <span>
                {`${props.value.from ? setStartOfDay(dayjs(props.value.from)).format(dateFormat) : 'Нет данных'}
                  - ${props.value.to ? setEndOfDay(dayjs(props.value.to)).format(dateFormat) : ' Нет данных'}`}
              </span>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

DateRangeAttribute.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.objectOf(PropTypes.any),
  isEditable: PropTypes.bool.isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
};

DateRangeAttribute.defaultProps = {
  value: {},
};

export default DateRangeAttribute;
